import { useState, useEffect, ReactNode, useMemo, useRef } from 'react';
import { Stepper, Step, StepLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import GoogleMapReact from 'google-map-react';
import CloseIcon from '@mui/icons-material/Close';
import JoditEditor from 'jodit-react';
import {
  Box,
  Button,
  Paper,
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Stack,
  TextField,
  Typography,
  FormControl,
  Radio,
  RadioGroup,
  Card,
  Select,
  MenuItem,
  InputLabel,
  Grid,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Chip,
  Switch,
  Container,
  Autocomplete,
  TableHead,
  Modal,
  InputAdornment,
} from '@mui/material';
import { Formik, useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import {
  useSaveLabourDetailMutation,
  useFindAllLabourDetailsMutation,
  useGetLabourDetailByIdMutation,
  useUpdateLabourDetailMutation,
} from '../../store/api/labourApi';
import {
  useFindAllAddressDetailMutation,
  useFindAddressDetailByIdMutation,
  useSaveAddressDetailMutation,
  useUpdateAddressDetailMutation,
  useDeleteAddressDetailMutation,
} from '../../store/api/labourAddressApi';
import {
  useGetAllLabourServiceDetailsMutation,
  useGetLabourServiceDetailByIdMutation,
  useCreateLabourServiceDetailMutation,
  useUpdateLabourServiceDetailMutation,
} from '../../store/api/labourJobApi';
import {
  useGetAllLabourReferencesMutation,
  useGetLabourReferenceByIdMutation,
  useCreateLabourReferenceMutation,
  useUpdateLabourReferenceMutation,
  useGetAllLabourReferencesByLabourIdMutation,
  useDeleteReferencesMutation,
} from '../../store/api/labourReferenceApi';
import {
  useUpdateLabourOfficialWorkMutation,
  useGetAllLabourOfficialWorksMutation,
  useCreateLabourOfficialWorkMutation,
  useGetLabourOfficialWorkByIdMutation,
} from '../../store/api/labourOfficialWorkApi';
import {
  useUpdateLabourDocumentDetailMutation,
  useSaveLabourDocumentDetailMutation,
  useUploadLabourDocumentMutation, useDeleteByIdMutation,
  useGetLabourDocumentsDetailsByLabourIdMutation,
} from '../../store/api/labourUploadDocApi';
import { useGetAllCountriesMutation } from '../../store/api/countriesApi';
import { setCountries } from '../../store/state/countrieSlice';
import { RootState } from '../../store/index';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker, LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import {
  useFindParkingSpaceLocationByIdMutation,
  useSaveParkingSpaceLocationMutation,
  useUpdateParkingSpaceLocationMutation,
} from '../../store/api/parkingsApi';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetAllServiceProviderDetailMutation } from '../../store/api/serviceProviderApi';
import {
  useDeleteParkingSpaceLocationImageMutation,
  useFindByParkingLocationIdMutation,
  useUploadParkingSpaceLocationImageMutation,
} from '../../store/api/parkingSpaceApi';
import { useGetEnumDataMutation } from '../../store/api/enumApi';
import { getSpecificEnumData, setEnumData } from '../../store/state/enumSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { useSaveMutation, useUpdateMutation } from '../../store/api/parkingTimeApi';
import {
  formatDateTime,
  formatTimeHHMM,
  GET_DAYS,
  getUTCTime,
  getISTTime,
  getUniqueKey,
} from '../../sections/@dashboard/parkingspaces/utility';
import LocationSearchInput from '../../sections/@dashboard/parkingspaces/PlaceLocationAutoComplete';
import { useGetParkingTypeDataMutation } from '../../store/api/parkingTypeApi';
import AllParkingsListHead from '../../sections/@dashboard/bookings/AllParkingsListHead';
import SearchNotFound from '../../components/SearchNotFound';
import {
  useGetBlackoutDatesMutation,
  useSaveBlackoutDateMutation,
  useUpdateBlackoutDateMutation,
} from '../../store/api/blackoutDayApi';
import { getBlackoutDay, setBlackoutDay } from '../../store/state/blackoutDaySlice';
import { format } from 'date-fns';
import toast from 'react-hot-toast';
import { getAuthDetails } from '../../store/state/authSlice';
import Loading from '../../components/Loading';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
  useGetParkingCategoryByIdMutation,
  useGetParkingCategoryDetailMutation,
  useSaveParkingCategoryDetailMutation,
  useUpdateParkingCategoryDetailMutation,
} from '../../store/api/parkingCategoryApi';
import { useGetCategoryListMutation, useGetSubCategoryListMutation } from '../../store/api/vehicleCategoryApi';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import DoneIcon from '@mui/icons-material/Done';
import Tooltip from '@mui/material/Tooltip';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import EditorToolbar, { modules, formats } from '../../components/EditorToolbar';
import { stubFalse } from 'lodash';
import { DomainVerificationRounded } from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({
  button: {
    marginRight: theme.spacing(1),
  },
}));

function getSteps() {
  return ['Personal', 'Address ', 'Job Details', 'References', 'Official Work', 'Upload Documents'];
}

const TABLE_HEAD = [
  { id: ' date', label: 'Date', alignRight: false },
  { id: 'description', label: 'Event', alignRight: false },
];

interface City {
  id: number;
  name: string;
  stateId: number;
}

interface State {
  id: number;
  name: string;
  countryId: number;
  cities: City[];
}

interface Country {
  id: number;
  name: string;
  states: State[];
}

type Reference = {
  id: string;
  referenceName: string;
  phoneNo: string;
  referenceType: string;
  feedback: number;
  saved?: boolean;
};

interface UploadDocuments {
  id: string;
  docType: string;
  path: string;
  onUpload: (file: File) => void;
  documentType: string;
  fileName: string;
  fileUrl: string;
}

const AddDriver = () => {
  const dispatch: any = useAppDispatch();
  const navigate = useNavigate();
  const classes = useStyles();
  const [flag, setFlag] = useState(false);
  const [condition, setCondition] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [skippedSteps, setSkippedSteps] = useState([]) as any;
  const [location, setLocation]: any = useState({});
  const [updateState, setUpdateState] = useState({});
  const steps = getSteps();
  const token = JSON.parse(localStorage.getItem('login') || '{}').token;
  const [updateParkingSpaceLocation, updateResponse] = useUpdateParkingSpaceLocationMutation();
  const { state }: any = useLocation();
  const [selectedOptions, setSelectedOptions] = useState() as any;
  const [selectedLabourId, setSelectedLabourId] = useState(null);
  const [referenceId, setReferenceId] = useState(null);
  const [signedUrl, setSignedUrl] = useState(null);
  const [serviceProviders, setServiceProviders] = useState<any>([]);
  //console.log(serviceProviders, 'serviceProviders');
  const [stateId, setStateId] = useState(null);
  const [findByParkingLocationId, findByParkingLocationIdResponse] = useFindByParkingLocationIdMutation();
  const [uploadedImage, setUploadedImage] = useState(null);
  const authData = JSON.parse(localStorage.getItem('login') || '{}');
  const [formValues, setFormValues] = useState({
    businessVertical: '',
    fullName: '',
    licenseNo: '',
    licExpiryDate: null,
    phone: '',
    altPhone: '',
    dob: null,
    email: '',
    gender: '',
    nationality: '',
    religion: '',
    maritalStatus: false,
    diet: '',
    language: '',
    photo: null,
    qualification: '',
    permanentAddress: '',
    location: '',
    addressLineOne: '',
    addressLineTwo: '',
    route: '',
    locality: '',
    city: '',
    zipCode: '',
    state: '',
    country: '',
    currentsameaspermanent: false,
    serviceSubCategory: '',
    asset: '',
    totalExperience: '',
    fullTime: false,
    partTime: false,
    day: false,
    night: false,
    outstation: false,
    referenceName: '',
    phoneNo: '',
    referenceType: '',
    feedback: '',
    trained: '',
    trainingDate: null,
    idCard: '',
    idCardIssueDate: null,
    uniform: '',
    uniformIssueDate: null,
    policeVerification: '',
    criminalVerification: '',
    backgroundCheck: '',
    certificateIssueDate: null,
    documentType: '',
    uploadFile: null,
  });


  const [rowdata, setRowData] = useState([]);
  const config: any = {
    toolbarAdaptive: false,
  };

  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('id');
  const [getParkingTypeData, getParkingTypeDataResponse] = useGetParkingTypeDataMutation();
  const [parkingManagementData, setParkingManagementData] = useState([]);
  const [saveLabourDetail, saveLabourDetailResponse] = useSaveLabourDetailMutation();
  const [updateLabourDetail, updateLabourDetailResponse] = useUpdateLabourDetailMutation();
  const [getLabourDetailById, getLabourDetailByIdResponse] = useGetLabourDetailByIdMutation();
  const [saveAddressDetail, saveAddressDetailResponse] = useSaveAddressDetailMutation();
  const [updateAddressDetail, updateAddressDetailResponse] = useUpdateAddressDetailMutation();
  const [findAddressDetailById, findAddressDetailByIdResponse] = useFindAddressDetailByIdMutation();
  const [createLabourServiceDetail, createLabourServiceDetailResponse] = useCreateLabourServiceDetailMutation();
  const [updateLabourServiceDetail, updateLabourServiceDetailResponse] = useUpdateLabourServiceDetailMutation();
  const [getLabourServiceDetailById, getLabourServiceDetailByIdResponse] = useGetLabourServiceDetailByIdMutation();
  const [createLabourReference, createLabourReferenceResponse] = useCreateLabourReferenceMutation();
  const [createLabourReferenceSubmit, createLabourReferenceSubmitResponse] = useCreateLabourReferenceMutation();
  const [updateLabourReference, updateLabourReferenceResponse] = useUpdateLabourReferenceMutation();
  const [getLabourReferenceById, getLabourReferenceByIdResponse] = useGetLabourReferenceByIdMutation();
  const [getAllLabourReferenceByLabourId, getAllLabourReferenceByLabourIdResponse] = useGetAllLabourReferencesByLabourIdMutation();
  const [deleteLabourReferences, deleteLabourReferencesResponse] = useDeleteReferencesMutation();
  const [getEnumData, enumResponse] = useGetEnumDataMutation();
  let enumData: any = useAppSelector(getSpecificEnumData);
  const [labourDocuments, setLabourDocuments] = useState([]);

  const [createLabourOfficialWork, createLabourOfficialWorkResponse] = useCreateLabourOfficialWorkMutation();
  const [updateLabourOfficialWork, updateLabourOfficialWorkResponse] = useUpdateLabourOfficialWorkMutation();
  const [getLabourOfficialWorkById, getLabourOfficialWorkByIdResponse] = useGetLabourOfficialWorkByIdMutation();

  const [updateLabourDocumentDetail, updateLabourDocumentDetailResponse] = useUpdateLabourDocumentDetailMutation();
  const [saveLabourDocumentDetail, saveLabourDocumentDetailResponse] = useSaveLabourDocumentDetailMutation();
  const [uploadLabourDocument, uploadLabourDocumentResponse] = useUploadLabourDocumentMutation();
  const [getLabourDocumentsDetailsByLabourId, getLabourDocumentsDetailsByLabourIdResponse] = useGetLabourDocumentsDetailsByLabourIdMutation();
  const [deleteDocumentById, deleteDocumentByIdResponse] = useDeleteByIdMutation();

  //const [allSavedReferences, setAllSavedReferences] = useState(false);
  const [getAllCountries, { data, isSuccess, isError, error, isLoading }] = useGetAllCountriesMutation();
  const countryData = useSelector((state: RootState) => state.countries.data || []);
  const [references, setReferences] = useState<Reference[]>([]);
  const [uploadDocuments, setUploadDocuments] = useState<UploadDocuments[]>([]);

  const [states, setStates] = useState<State[]>([]);
  const [cities, setCities] = useState<City[]>([]);
  const [selectedCountryId, setSelectedCountryId] = useState<number | null>(null);
  const [selectedStateId, setSelectedStateId] = useState<number | null>(null);
  const [selectedCityId, setSelectedCityId] = useState<number | null>(null);


  const saveLabourDataToServer = async (values: any) => {
    await saveLabourDetail({
      payload: getPayload(activeStep, values),
      token: token,
    });
  };
  useEffect(() => {
    if (saveLabourDetailResponse.isSuccess) {
      setActiveStep(activeStep + 1);
      setSelectedLabourId(saveLabourDetailResponse.data.id);
    } else if (saveLabourDetailResponse.error) {
      let errorData: any = saveLabourDetailResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;

      if (msg) {
        toast.error(msg);
      } else {
        toast.error('Technical issue, please try again!!!');
      }
    }
  }, [saveLabourDetailResponse.isSuccess, saveLabourDetailResponse.error]);

  // const UpdateLabourDataToServer = async (values: any) => {
  //   await updateLabourDetail({
  //     payload: getPayload(activeStep, values),
  //     token: token,
  //   });
  // };

  useEffect(() => {
    if (updateLabourDetailResponse.isSuccess) {
      setActiveStep(activeStep + 1);
    }
    if (updateLabourDetailResponse.error) {
      let errorData: any = updateLabourDetailResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      if (msg) {
        toast.error(msg);
      } else {
        toast.error('Technical issue, please try again!!!');
      }
    }
  }, [updateLabourDetailResponse.error]);

  const saveLabourAddressDataToServer = async (values: any) => {
    await saveAddressDetail({
      payload: getPayload(activeStep, values),
      token: token,
    });
  };

  useEffect(() => {
    if (saveAddressDetailResponse.isSuccess) {

      const updatedLabourDetails = {
        isEdit: true,
        isAddress: true,
        currentAddressId: saveAddressDetailResponse.data.id,
        currentAddress: saveAddressDetailResponse.data.address,
        id: state.editMode || state.isApprove ? state.id : selectedLabourId,
        stage: "address",
      };
      updateLabourDetail({
        payload: updatedLabourDetails,
        token: token,
      });

      setActiveStep(activeStep + 1);

    } else if (saveAddressDetailResponse.error) {
      let errorData: any = saveAddressDetailResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;

      if (msg) {
        toast.error(msg);
      } else {
        toast.error('Technical issue, please try again!!!');
      }
    }
  }, [saveAddressDetailResponse.isSuccess, saveAddressDetailResponse.error]);

  // const updateLabourAddressDataToServer = async (values: any) => {
  //  await updateAddressDetail({
  //    payload: getPayload(activeStep, values),
  //     token: token,
  //   });
  // };

  useEffect(() => {
    if (updateAddressDetailResponse.isSuccess) {
      setActiveStep(activeStep + 1);
    }
    if (updateAddressDetailResponse.error) {
      let errorData: any = updateAddressDetailResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      if (msg) {
        toast.error(msg);
      } else {
        toast.error('Technical issue, please try again!!!');
      }
    }
  }, [updateAddressDetailResponse.error]);


  const saveLabourServiceDataToServer = async (values: any) => {
    await createLabourServiceDetail({
      payload: getPayload(activeStep, values),
      token: token,
    });
  };
  useEffect(() => {
    if (createLabourServiceDetailResponse.isSuccess) {

      const updatedLabourDetails = {
        isEdit: true,
        isServiceDetails: true,
        serviceId: createLabourServiceDetailResponse.data.id,
        id: state.editMode || state.isApprove ? state.id : selectedLabourId,
        stage: "service",
      };
      updateLabourDetail({
        payload: updatedLabourDetails,
        token: token,
      });

      setActiveStep(activeStep + 1);

    } else if (createLabourServiceDetailResponse.error) {
      let errorData: any = createLabourServiceDetailResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;

      if (msg) {
        toast.error(msg);
      } else {
        toast.error('Technical issue, please try again!!!');
      }
    }
  }, [createLabourServiceDetailResponse.isSuccess, createLabourServiceDetailResponse.error]);

  //const updateLabourServiceDataToServer = async (values: any) => {
  //  await updateLabourServiceDetail({
  //    payload: getPayload(activeStep, values),
  //     token: token,
  //   });
  // };

  useEffect(() => {
    if (updateLabourServiceDetailResponse.isSuccess) {
      setActiveStep(activeStep + 1);
    }
    if (updateLabourServiceDetailResponse.error) {
      let errorData: any = updateLabourServiceDetailResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      if (msg) {
        toast.error(msg);
      } else {
        toast.error('Technical issue, please try again!!!');
      }
    }
  }, [updateLabourServiceDetailResponse.error]);


  const saveLabourReferenceSubmitDataToServer = async (values: any) => {
    const updatedLabourDetails = {
      isEdit: true,
      isReferences: true,
      id: state.editMode || state.isApprove ? state.id : selectedLabourId,
      stage: "references",
    };

    try {
      const submitResponse = await updateLabourDetail({
        payload: updatedLabourDetails,
        token: token,
      });

      if (submitResponse) {
        setActiveStep(activeStep + 1);
      } else {
        toast.error('Failed to save labour reference data');
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error('Technical issue, please try again!');
    }
  };


  const saveDocumentSubmitDataToServer = async (values: any) => {
    const updatedLabourDetails = {
      isEdit: true,
      isUpload: true,
      id: state.editMode || state.isApprove ? state.id : selectedLabourId,
      stage: "document",
    };

    try {
      const submitResponse = await updateLabourDetail({
        payload: updatedLabourDetails,
        token: token,
      });

      if (submitResponse) {
        toast.success("Driver Added Successfully");
      } else {
        toast.error('Failed to Add Driver data');
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error('Technical issue, please try again!');
    }
  };


  //const saveLabourReferenceDataToServer = async (values: any, refId: number | undefined) => {

  //  await createLabourReference({
  //    payload: getPayload(activeStep, values, refId),
  //    token: token,
  //  });
  // }; 

  const saveLabourReferenceDataToServer = async (values: any, refId: number | undefined) => {
    const payload = getPayload(activeStep, values, refId) as { [key: string]: any };
    const updatedPayload = {
      ...payload,
      isEdit: false,
    };
    await createLabourReference({
      payload: updatedPayload,
      token: token,
    });
  };
  useEffect(() => {
    if (createLabourReferenceResponse.isSuccess) {
      setReferenceId(createLabourReferenceResponse.data.id);

    } else if (createLabourReferenceResponse.error) {
      let errorData: any = createLabourReferenceResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;

      if (msg) {
        toast.error(msg);
      } else {
        toast.error('Technical issue, please try again!!!');
      }
    }
  }, [createLabourReferenceResponse.isSuccess, createLabourReferenceResponse.error]);

  const updateLabourReferenceDataToServer = async (values: any, refId: number | undefined) => {
    const payload = getPayload(activeStep, values, refId) as { [key: string]: any };
    const updatedPayload = {
      ...payload,
      isEdit: true,
    };
    createLabourReference({
      payload: updatedPayload,
      token: token,
    });
  };

  const deleteLabourReferenceDataFromServer = async (values: any, refId: number | undefined) => {

    await deleteLabourReferences({
      payload: getPayload(activeStep, values, refId),
      token: token,
    });
  };
  useEffect(() => {
    if (deleteLabourReferencesResponse.isSuccess) {

    } else if (deleteLabourReferencesResponse.error) {
      let errorData: any = deleteLabourReferencesResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;

      if (msg) {
        toast.error(msg);
      } else {
        toast.error('Technical issue, please try again!!!');
      }
    }
  }, [deleteLabourReferencesResponse.isSuccess, deleteLabourReferencesResponse.error]);

  const deleteDocumentDataFromServer = async (values: any, docId: number | undefined) => {
    if (!docId) {
      console.log("Handle Delete Server Id is undefined:", docId);
      return;
    }
    console.log("Handle Delete Server Id:", docId);

    await deleteDocumentById({
      payload: getPayload(activeStep, values, undefined, docId),
      token: token,
    });
  };
  useEffect(() => {
    if (deleteDocumentByIdResponse.isSuccess) {

    } else if (deleteDocumentByIdResponse.error) {
      let errorData: any = deleteDocumentByIdResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;

      if (msg) {
        toast.error(msg);
      } else {
        toast.error('Technical issue, please try again!!!');
      }
    }
  }, [deleteDocumentByIdResponse.isSuccess, deleteDocumentByIdResponse.error]);

  const saveLabourOfficialWorkDataToServer = async (values: any) => {
    await createLabourOfficialWork({
      payload: getPayload(activeStep, values),
      token: token,
    });
  };

  useEffect(() => {
    if (createLabourOfficialWorkResponse.isSuccess) {

      const updatedLabourDetails = {
        isEdit: true,
        isOfficialWork: true,
        id: state.editMode || state.isApprove ? state.id : selectedLabourId,
        stage: "official",
      };
      updateLabourDetail({
        payload: updatedLabourDetails,
        token: token,
      });

      setActiveStep(activeStep + 1);

    } else if (createLabourOfficialWorkResponse.error) {
      let errorData: any = createLabourOfficialWorkResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;

      if (msg) {
        toast.error(msg);
      } else {
        toast.error('Technical issue, please try again!!!');
      }
    }
  }, [createLabourOfficialWorkResponse.isSuccess, createLabourOfficialWorkResponse.error]);

  //const updateLabourOfficialWorkDataToServer = async (values: any) => {
  // await updateLabourOfficialWork({
  //   payload: getPayload(activeStep, values),
  //   token: token,
  // });
  //};

  useEffect(() => {
    if (updateLabourOfficialWorkResponse.isSuccess) {
      //setActiveStep(activeStep + 1);
    }
    if (updateLabourOfficialWorkResponse.error) {
      let errorData: any = updateLabourOfficialWorkResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      if (msg) {
        toast.error(msg);
      } else {
        toast.error('Technical issue, please try again!!!');
      }
    }
  }, [updateLabourOfficialWorkResponse.error]);


  useEffect(() => {
    if (token) {
      getAllCountries({ token });
    }
  }, [token, getAllCountries]);

  useEffect(() => {
    if (isSuccess && data) {
      dispatch(
        setCountries({
          data,
          totalRecords: data.length,
          currentPage: 1,
          totalPages: 1,
        })
      );
      //console.log("Get All Countries:", data[0].states);
    } else if (isError) {
      console.error('Failed to fetch countries:', error);
    }
  }, [isSuccess, data, isError, error, dispatch]);


  useEffect(() => {

    if (selectedCountryId !== null) {
      const selectedCountry = countryData.find((country: Country) => country.id === selectedCountryId);
      if (selectedCountry) {
        setStates(selectedCountry.states || []);
        setCities([]);
        setSelectedStateId(null);
        setSelectedCityId(null);
      }
    }
  }, [selectedCountryId]);

  useEffect(() => {
    if (selectedStateId !== null) {
      const selectedState = states.find((state) => state.id === selectedStateId);
      if (selectedState) {
        setCities(selectedState.cities || []);
        setSelectedCityId(null);
      }
    }
  }, [selectedStateId, states]);

  const handleCountryChange = (countryId: number) => {
    setSelectedCountryId(countryId);
  };

  const handleStateChange = (stateId: number) => {
    setSelectedStateId(stateId);
  };

  const handleCityChange = (cityId: number) => {
    setSelectedCityId(cityId);
  };

  const getParkingTypeDataAsync = async (rowPerPages: any, pages: number, orders: string, typeNames = '') => {
    await getParkingTypeData({
      token: token,
      payload: {
        offset: rowPerPages,
        pageNumber: pages,
        sortOrder: orders,
        typeName: typeNames,
      },
    });
  };

  useEffect(() => {
    if (token) {
      getParkingTypeDataAsync(2000, 0, order);
    }
  }, []);

  useEffect(() => {
    if (getParkingTypeDataResponse.isSuccess) {
      const parkingType = getParkingTypeDataResponse.data.data.filter((item: any) => {
        return item.status == true;
      });
      setParkingManagementData(parkingType);
    }
  }, [getParkingTypeDataResponse.isSuccess]);

  useEffect(() => {
    getEnumData({ token: token });
  }, []);

  useEffect(() => {
    if (enumResponse.isSuccess) {
      dispatch(setEnumData(enumResponse.data));
    }
  }, [enumResponse.isSuccess]);

  useEffect(() => {
    if (enumData) {
      setLabourDocuments(enumData['LABOUR_DOCUMENTS']);
    }
  }, [enumData]);

  const handleFileUpload = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    uploadLabourDocument({
      token,
      payload: formData,
    });
  };

  useEffect(() => {
    if (uploadLabourDocumentResponse.isSuccess) {
      //console.log("uploadLabourDocumentResponse",uploadLabourDocumentResponse);
      //console.log("uploadLabourDocumentResponse.data",uploadLabourDocumentResponse.data);
      setSignedUrl(uploadLabourDocumentResponse.data.signedURL);
      //console.log("setSignedUrl",setSignedUrl);
    } else if (uploadLabourDocumentResponse.error) {
      let errorData: any = uploadLabourDocumentResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      if (msg) {
        toast.error(msg);
      } else {
        toast.error('Technical issue, please try again!!!');
      }
    }
  }, [uploadLabourDocumentResponse.isSuccess, uploadLabourDocumentResponse.error]);


  const saveLabourDocumentDataToServer = async (values: any) => {
    const payload = getPayload(activeStep, values) as { [key: string]: any };
    const updatedPayload = {
      ...payload,
      isEdit: false,
    };
    await saveLabourDocumentDetail({
      payload: updatedPayload,
      token: token,
    });
  };
  useEffect(() => {
    if (saveLabourDocumentDetailResponse.isSuccess) {
      const labourId = saveLabourDocumentDetailResponse.data.labourId;
      getLabourDocumentsDetailsByLabourId({
        token: token,
        id: labourId,
      });
    } else if (saveLabourDocumentDetailResponse.error) {
      let errorData: any = saveLabourDocumentDetailResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;

      if (msg) {
        toast.error(msg);
      } else {
        toast.error('Technical issue, please try again!!!');
      }
    }
  }, [saveLabourDocumentDetailResponse.isSuccess, saveLabourDocumentDetailResponse.error]);


  const handleRequestSort = (event: any, property: any) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  function getPayload(step: any, values: any, refId?: number, docId?: number) {

    console.log("Payload Function - Doc ID:", docId);
    console.log("Selected Labour Id", selectedLabourId);
    console.log("State Id:", state.id);
    const addressId =
      state.editMode || state.isApprove
        ? state.currentStep === 'Personal'
          ? state.id
          : getLabourDetailByIdResponse.data?.currentAddressId
        : selectedLabourId;


    const serviceId =
      state.editMode || state.isApprove
        ? state.currentStep === 'Personal'
          ? state.id
          : getLabourDetailByIdResponse.data?.labourServiceDetails?.[0]?.id
        : selectedLabourId;

    //const referenceId =
    //state.editMode || state.isApprove
    //  ? state.currentStep === 'Personal'
    //    ? state.id
    //   : getLabourDetailByIdResponse.data?.labourReferences?.[0]?.id
    //   : selectedLabourId;

    const officialWorkId =
      state.editMode || state.isApprove
        ? state.currentStep === 'Personal'
          ? state.id
          : getLabourDetailByIdResponse.data?.labourOfficialWorks?.[0]?.id
        : selectedLabourId;


    const documentId =
      state.editMode || state.isApprove
        ? state.currentStep === 'Personal'
          ? state.id
          : getLabourDetailByIdResponse.data?.labourDocumentDetails?.[0]?.id
        : selectedLabourId;


    switch (step) {
      case 0:
        return {
          flag: 'Personal',
          fullName: values.fullName,
          registeredPhoneNumber: values.registeredPhone,
          alternatePhoneNumber: values.altPhone,
          residencePhoneNumber: values.residencePhone,
          dob: values.dob ? format(new Date(values.dob), "yyyy-MM-dd") : null,
          licenseNo: values.licenseNo,
          licExpiryDate: values.licExpiryDate ? format(new Date(values.licExpiryDate), "yyyy-MM-dd") : null,
          emailId: values.email,
          gender: values.gender,
          nationalityId: values.nationality,
          religion: values.religion,
          isMarried: values.maritalStatus,
          diet: values.diet,
          languages: values.language,
          parkingTypeId: values.businessVertical,
          qualification: values.qualification,
          isPersonal: true,
          status: true,
          serviceProviderId: state.isAdmin || state.isApprove ? selectedOptions?.id : authData.serviceProviderId,
          isEdit: state.editMode,
          id: state.editMode || state.isApprove ? state.id : selectedLabourId,
          isConform: state.isApprove,
          stage: " ",
          userId: state.editMode || state.isApprove ? getLabourDetailByIdResponse.data?.userId : '',
        };
      case 1:
        return {
          flag: 'Address',
          location: location.formatted_address,
          latitude: location?.lat,
          longitude: location?.lng,
          line1: values.addressLineOne,
          line2: values.addressLineTwo,
          route: values.route,
          locality: values.locality,
          cityId: values.city,
          zipCode: values.zipCode,
          stateId: values.state,
          countryId: values.country,
          address: values.permanentAddress,
          isAddDriverForm: true,
          isCurrentAddressIsSamePermanent: values.currentsameaspermanent,
          isPermanentAddress: values.permanentAddress.trim() !== "",
          serviceProviderId: state.isAdmin || state.isApprove ? selectedOptions?.id : authData.serviceProviderId,
          isEdit: state.editMode,
          labourId: state.editMode || state.isApprove ? state.id : selectedLabourId,
          id: state.editMode ? addressId : state.id || selectedLabourId,
          isConform: state.isApprove,
          stage: "address",
        };

      case 2:
        return {
          flag: 'Job Details',
          //serviceSubCategory: values.serviceSubCategory || '',
          //asset: values.asset || '',
          totExperience: values.totalExperience || '',
          experience: values.overseasExperience || '',
          isFullTime: values.fullTime || false,
          isPartTime: values.partTime || false,
          isDay: values.day || false,
          isNight: values.night || false,
          isOutstation: values.outstation || false,
          remark: values.remarks || '',
          serviceProviderId: state.isAdmin || state.isApprove ? selectedOptions?.id : authData.serviceProviderId,
          isEdit: state.editMode,
          labourId: state.editMode || state.isApprove ? state.id : selectedLabourId,
          id: state.editMode ? serviceId : state.id || selectedLabourId,
          isConform: state.isApprove,
          stage: "service",
        };

      case 3:
        return {
          flag: 'References',
          referenceName: values.referenceName || "",
          phoneNo: values.phoneNo || "",
          referenceType: values.referenceType || "",
          feedback: values.feedback || "",
          status: true,
          serviceProviderId: state.isAdmin || state.isApprove ? selectedOptions?.id : authData.serviceProviderId,
          isEdit: state.editMode,
          labourId: state.editMode || state.isApprove ? state.id : selectedLabourId,
          id: state.editMode ? refId : state.id || referenceId,
          isConform: state.isApprove,
          stage: "references",
        };
      case 4:
        return {
          flag: 'Official Work',
          isTrained: values.trained || false,
          trainingDate: values.trainingDate ? format(new Date(values.trainingDate), "yyyy-MM-dd") : null,
          isIdCardIssued: values.idCard || false,
          idCardIssueDate: values.idCardIssueDate ? format(new Date(values.idCardIssueDate), "yyyy-MM-dd") : null,
          isUniform: values.uniform || false,
          uniformIssueDate: values.uniformIssueDate ? format(new Date(values.uniformIssueDate), "yyyy-MM-dd") : null,
          isPoliceVerification: values.policeVerification || false,
          isCourtCriminalVerification: values.criminalVerification || false,
          otherBackgroundCheck: values.backgroundCheck || false,
          certificateIssueDate: values.certificateIssueDate ? format(new Date(values.certificateIssueDate), "yyyy-MM-dd") : null,
          remarks: values.remarksow || "",
          serviceProviderId: state.isAdmin || state.isApprove ? selectedOptions?.id : authData.serviceProviderId,
          isEdit: state.editMode,
          labourId: state.editMode || state.isApprove ? state.id : selectedLabourId,
          id: state.editMode ? officialWorkId : state.id || selectedLabourId,
          isConform: state.isApprove,
          stage: "official",
        };

      case 5:
        return {
          flag: 'Upload Documents',
          docType: values.documentType || "",
          path: signedUrl,
          status: true,
          serviceProviderId: selectedOptions?.id,
          isEdit: state.editMode,
          labourId: state.editMode || state.isApprove ? state.id : selectedLabourId,
          id: state.editMode ? docId : state.id || documentId,
          isConform: state.isApprove,
          stage: "document",
        };
      default:
        return 'unknown step';
    }
  }

  const handleSubmit = (values: any) => {
    if (activeStep === 6) {
      setActiveStep(activeStep + 1);
    } else {
      if (activeStep === 0) {
        saveLabourDataToServer(values);
      } else if (activeStep === 1) {
        saveLabourAddressDataToServer(values);
      } else if (activeStep === 2) {
        saveLabourServiceDataToServer(values);
      } else if (activeStep === 3) {
        saveLabourReferenceSubmitDataToServer(values);
      } else if (activeStep === 4) {
        saveLabourOfficialWorkDataToServer(values);
      } else if (activeStep === 5) {
        saveDocumentSubmitDataToServer(values);
        navigate('/dashboard/driver-details');
      } else {
        setActiveStep(activeStep + 1);
      }
      setFormValues(values);
    }
    setSkippedSteps(skippedSteps.filter((skipItem: any) => skipItem !== activeStep));
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
    getLabourDetailById({
      id: state?.editMode || state?.isApprove ? state?.id : selectedLabourId,
      token: token,
    });
  };

  const handleStep = (step: number) => () => {
    setActiveStep(step);
  };

  useEffect(() => {
    if (state?.editMode || state?.isApprove) {
      getLabourDetailById({
        token: token,
        id: state.id,
      });
    }
  }, [state?.editMode, state?.isApprove, getLabourDetailById, token, state?.id]);

  useEffect(() => {
    if (getLabourDetailByIdResponse.isSuccess) {
      setUpdateState(getLabourDetailByIdResponse.data);

      const fetchedLanguages = getLabourDetailByIdResponse.data?.languages || [];
      const fetchedParkingTypeIds = getLabourDetailByIdResponse.data?.parkingTypeId || [];

      setFormValues((prevState) => ({
        ...prevState,
        fullName: getLabourDetailByIdResponse.data?.fullName || '',
        registeredPhone: getLabourDetailByIdResponse.data?.registeredPhoneNumber || '',
        altPhone: getLabourDetailByIdResponse.data?.alternatePhoneNumber || '',
        residencePhone: getLabourDetailByIdResponse.data?.residencePhoneNumber || '',
        dob: getLabourDetailByIdResponse.data?.dob || null,
        licenseNo: getLabourDetailByIdResponse.data?.licenseNo || '',
        licExpiryDate: getLabourDetailByIdResponse.data?.licExpiryDate || null,
        email: getLabourDetailByIdResponse.data?.emailId || '',
        gender: getLabourDetailByIdResponse.data?.gender || '',
        nationality: getLabourDetailByIdResponse.data?.nationalityId || '',
        religion: getLabourDetailByIdResponse.data?.religion || '',
        maritalStatus: getLabourDetailByIdResponse.data?.isMarried || false,
        diet: getLabourDetailByIdResponse.data?.diet || '',
        language: fetchedLanguages,
        //photo: getLabourDetailByIdResponse.data?.photo || null,
        businessVertical: fetchedParkingTypeIds,
        qualification: getLabourDetailByIdResponse.data?.qualification || '',
      }));
    }
  }, [getLabourDetailByIdResponse.isSuccess]);

  useEffect(() => {
    if (state?.editMode || state?.isApprove) {
      const addressId = state.currentStep === 'Personal'
        ? state.id
        : getLabourDetailByIdResponse.data?.currentAddressId;

      if (addressId) {
        findAddressDetailById({
          token: token,
          id: addressId,
        });
      }
    }
  }, [state?.editMode, state?.isApprove, state?.currentStep, findAddressDetailById, token, state?.id, getLabourDetailByIdResponse.data?.currentAddressId]);

  useEffect(() => {
    if (findAddressDetailByIdResponse.isSuccess) {
      setUpdateState(findAddressDetailByIdResponse.data);
      setFormValues((prevState) => ({
        ...prevState,
        permanentAddress: findAddressDetailByIdResponse.data?.address || '',
        location: findAddressDetailByIdResponse.data?.location || '',
        addressLineOne: findAddressDetailByIdResponse.data?.line1 || '',
        addressLineTwo: findAddressDetailByIdResponse.data?.line2 || '',
        route: findAddressDetailByIdResponse.data?.route || '',
        locality: findAddressDetailByIdResponse.data?.locality || '',
        city: findAddressDetailByIdResponse.data?.cityId || '',
        zipCode: findAddressDetailByIdResponse.data?.zipCode || '',
        state: findAddressDetailByIdResponse.data?.stateId || '',
        country: findAddressDetailByIdResponse.data?.countryId || '',

      }));
      if (state?.editMode) {
        const fetchedCountryId = findAddressDetailByIdResponse.data?.countryId;
        const fetchedStateId = findAddressDetailByIdResponse.data?.stateId;
        const fetchedCityId = findAddressDetailByIdResponse.data?.cityId;

        if (fetchedCountryId) {
          setSelectedCountryId(fetchedCountryId);

          const selectedCountry = countryData.find(
            (country: Country) => country.id === fetchedCountryId
          );
          if (selectedCountry) {
            setStates(selectedCountry.states || []);
          }
        }

        if (fetchedStateId) {
          setSelectedStateId(fetchedStateId);

          const selectedState = states.find(
            (state) => state.id === fetchedStateId
          );
          if (selectedState) {
            setCities(selectedState.cities || []);
          }
        }

        if (fetchedCityId) {
          setSelectedCityId(fetchedCityId);
        }
      }
    }
  }, [findAddressDetailByIdResponse.isSuccess]);


  useEffect(() => {
    if (state?.editMode || state?.isApprove) {

      const serviceDetailId = getLabourDetailByIdResponse.data?.labourServiceDetails?.[0]?.id;

      if (serviceDetailId) {
        console.log("Service Detail Id :", serviceDetailId);
        getLabourServiceDetailById({
          token: token,
          id: serviceDetailId,
        });
      }
    }
  }, [state?.editMode, state?.isApprove, getLabourDetailByIdResponse.data, getLabourServiceDetailById, token]);

  useEffect(() => {
    if (getLabourServiceDetailByIdResponse.isSuccess) {
      console.log("getLabourServiceDetailByIdResponse", getLabourServiceDetailByIdResponse.data);
      setUpdateState(getLabourServiceDetailByIdResponse.data);
      setFormValues((prevState) => ({
        ...prevState,
        totalExperience: getLabourServiceDetailByIdResponse.data?.totExperience || '',
        overseasExperience: getLabourServiceDetailByIdResponse.data?.experience || '',
        day: getLabourServiceDetailByIdResponse.data?.isDay || '',
        night: getLabourServiceDetailByIdResponse.data?.isNight || '',
        outstation: getLabourServiceDetailByIdResponse.data?.isOutstation || '',
        fullTime: getLabourServiceDetailByIdResponse.data?.isFullTime || '',
        partTime: getLabourServiceDetailByIdResponse.data?.isPartTime || '',
        remarks: getLabourServiceDetailByIdResponse.data?.remark || '',

      }));
    }
  }, [getLabourServiceDetailByIdResponse.isSuccess]);


  useEffect(() => {
    if (state?.editMode || state?.isApprove) {

      const labourId = getLabourDetailByIdResponse.data?.id;

      if (labourId) {
        getAllLabourReferenceByLabourId({
          token: token,
          id: labourId,
        });
      }
    }
  }, [state?.editMode, state?.isApprove, getLabourDetailByIdResponse.data, getAllLabourReferenceByLabourId, token, state?.id]);
  useEffect(() => {
    if (getAllLabourReferenceByLabourIdResponse.isSuccess) {
      setReferences(getAllLabourReferenceByLabourIdResponse.data || []);
    }
  }, [getAllLabourReferenceByLabourIdResponse.isSuccess]);

  useEffect(() => {
    if (state?.editMode || state?.isApprove) {

      const officialWorkId = getLabourDetailByIdResponse.data?.labourOfficialWorks?.[0]?.id;

      if (officialWorkId) {
        getLabourOfficialWorkById({
          token: token,
          id: officialWorkId,
        });
      }
    }
  }, [state?.editMode, state?.isApprove, getLabourDetailByIdResponse.data, getAllLabourReferenceByLabourId, token, state?.id]);
  useEffect(() => {
    if (getLabourOfficialWorkByIdResponse.isSuccess) {
      setUpdateState(getLabourOfficialWorkByIdResponse.data);
      setFormValues((prevState) => ({
        ...prevState,
        trained:
          getLabourOfficialWorkByIdResponse.data?.isTrained !== undefined
            ? getLabourOfficialWorkByIdResponse.data.isTrained
            : '',
        trainingDate: getLabourOfficialWorkByIdResponse.data?.trainingDate || '',
        idCard:
          getLabourOfficialWorkByIdResponse.data?.isIdCardIssued !== undefined
            ? getLabourOfficialWorkByIdResponse.data.isIdCardIssued
            : '',
        idCardIssueDate: getLabourOfficialWorkByIdResponse.data?.idCardIssueDate || '',
        uniform:
          getLabourOfficialWorkByIdResponse.data?.isUniform !== undefined
            ? getLabourOfficialWorkByIdResponse.data.isUniform
            : '',
        uniformIssueDate: getLabourOfficialWorkByIdResponse.data?.uniformIssueDate || '',
        policeVerification:
          getLabourOfficialWorkByIdResponse.data?.isPoliceVerification !== undefined
            ? getLabourOfficialWorkByIdResponse.data.isPoliceVerification
            : '',
        criminalVerification:
          getLabourOfficialWorkByIdResponse.data?.isCourtCriminalVerification !== undefined
            ? getLabourOfficialWorkByIdResponse.data.isCourtCriminalVerification
            : '',
        backgroundCheck:
          getLabourOfficialWorkByIdResponse.data?.otherBackgroundCheck !== undefined
            ? getLabourOfficialWorkByIdResponse.data.otherBackgroundCheck
            : '',
        certificateIssueDate: getLabourOfficialWorkByIdResponse.data?.certificateIssueDate || '',
        remarksow: getLabourOfficialWorkByIdResponse.data?.remarks || '',
      }));
    }
  }, [getLabourOfficialWorkByIdResponse.isSuccess]);

  useEffect(() => {
    if (state?.editMode || state?.isApprove) {

      const labourId = getLabourDetailByIdResponse.data?.id;

      if (labourId) {
        getLabourDocumentsDetailsByLabourId({
          token: token,
          id: labourId,
        });
      }
    }
  }, [state?.editMode, state?.isApprove, getLabourDetailByIdResponse.data, getLabourDocumentsDetailsByLabourId, token, state?.id]);
  useEffect(() => {
    if (getLabourDocumentsDetailsByLabourIdResponse.isSuccess) {
      setUploadDocuments(getLabourDocumentsDetailsByLabourIdResponse.data || []);
    }
  }, [getLabourDocumentsDetailsByLabourIdResponse.isSuccess]);



  return (
    <div>
      <Card>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          marginBottom={'25px'}
          marginLeft={'35px'}
          marginTop={'25px'}
        >
          <Typography variant="h4" gutterBottom>
            {state?.editMode
              ? 'Update Driver'
              : state?.isApprove
                ? 'Confirm Driver'
                : 'Add New Driver'}
          </Typography>

          <Button
            variant="contained"
            style={{ color: 'white', backgroundColor: '#E23744' }}
            onClick={() => {
              state?.isApprove
                ? navigate('/dashboard/new-parking-requests')
                : state?.isAdmin
                  ? navigate('/dashboard/driver-details')
                  : navigate('/dashboard/driver-details');
            }}
            sx={{ marginBottom: '10px' }}
            size="medium"
          >
            <ArrowBackIcon />
          </Button>
        </Stack>
        {state?.editMode || state?.isApprove ? (
          <div
            style={{
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              scrollbarWidth: 'none',
            }}
          >
            <Stepper
              nonLinear
              activeStep={activeStep}
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
              }}
            >
              {steps.map((step, index) => {
                const stepProps = {};
                return (
                  <Step {...stepProps} key={index}>
                    <StepLabel
                      style={{
                        cursor: 'pointer',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                      onClick={handleStep(index)}
                    >
                      {step}
                    </StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </div>
        ) : (
          <div
            style={{
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              scrollbarWidth: 'none',
            }}
          >
            <Stepper
              nonLinear
              activeStep={activeStep}
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
              }}
            >
              {steps.map((step, index) => {
                const labelProps = {};
                const stepProps = {};
                return (
                  <Step {...stepProps} key={index}>
                    <StepLabel
                      {...labelProps}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      {step}
                    </StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </div>
        )}
        <Formik
          initialValues={formValues}
          enableReinitialize={true}
          validate={validate[activeStep]}
          onSubmit={handleSubmit}
          render={({ values, errors, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
            <form onSubmit={handleSubmit}>
              {activeStep === 0 && (
                <Personal
                  countryData={countryData}
                  parkingManagementData={parkingManagementData}
                  values={values}
                  errors={errors}
                  updateState={updateState}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  setFieldValue={setFieldValue}
                />
              )}
              {activeStep === 1 && (
                <Address
                  values={values}
                  errors={errors}
                  setLocation={setLocation}
                  state={state}
                  token={token}
                  countryData={countryData}
                  stateData={states}
                  cityData={cities}
                  selectedCountryId={selectedCountryId}
                  selectedStateId={selectedStateId}
                  selectedCityId={selectedCityId}
                  selectedLabourId={selectedLabourId}
                  handleCountryChange={handleCountryChange}
                  handleStateChange={handleStateChange}
                  handleCityChange={handleCityChange}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  setFieldValue={setFieldValue}
                />
              )}
              {activeStep === 2 && (
                <JobDetails
                  values={values}
                  errors={errors}
                  state={state}
                  token={token}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  setFieldValue={setFieldValue}
                />
              )}
              {activeStep === 3 && (
                <References
                  values={values}
                  errors={errors}
                  state={state}
                  token={token}
                  saveReferenceData={saveLabourReferenceDataToServer}
                  updateReferenceData={updateLabourReferenceDataToServer}
                  deleteReferenceData={deleteLabourReferenceDataFromServer}
                  references={references}
                  setReferences={setReferences}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  setFieldValue={setFieldValue}
                  IconButton={IconButton}
                  EditIcon={EditIcon}
                  DeleteIcon={DeleteIcon}
                  SaveIcon={SaveIcon}
                  Tooltip={Tooltip}
                  DoneIcon={DoneIcon}
                  classes={classes}
                />
              )}
              {activeStep === 4 && (
                <OfficialWork
                  values={values}
                  errors={errors}
                  state={state}
                  token={token}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  setFieldValue={setFieldValue}
                />
              )}

              {activeStep === 5 && (
                <UploadDocuments
                  values={values}
                  errors={errors}
                  state={state}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  labourDocuments={labourDocuments}
                  uploadDocuments={uploadDocuments}
                  setUploadDocuments={setUploadDocuments}
                  deleteDocumentData={deleteDocumentDataFromServer}
                  onUpload={handleFileUpload}
                  setFieldValue={setFieldValue}
                  saveLabourDocumentDataToServer={saveLabourDocumentDataToServer}
                  signedUrl={signedUrl}
                  IconButton={IconButton}
                  Tooltip={Tooltip}
                  EditIcon={EditIcon}
                  DeleteIcon={DeleteIcon}
                  SaveIcon={SaveIcon}
                  SaveAltIcon={SaveAltIcon}
                  DoneIcon={DoneIcon}
                  classes={classes}
                />
              )}

              <Box display={'flex'} justifyContent={'end'} padding={4}>
                <Box>
                  <Button className={classes.button} disabled={activeStep === 0} onClick={handleBack}>
                    Back
                  </Button>
                </Box>
                <Box>
                  <Button
                    type="submit"
                    className={classes.button}
                    style={{ color: 'white', backgroundColor: '#E23744' }}
                    variant="contained"
                    color="primary"
                  //disabled={activeStep === 3 && !allSavedReferences}

                  >
                    {activeStep === steps.length - 1 ? (state.isApprove ? ' Confirm' : 'Finish') : 'Next'}
                  </Button>
                </Box>
              </Box>
            </form>
          )}
        />
      </Card>
      {updateLabourDetailResponse.isLoading ||
        saveLabourDetailResponse.isLoading ||
        getParkingTypeDataResponse.isLoading ||
        saveAddressDetailResponse.isLoading ||
        findAddressDetailByIdResponse.isLoading ||
        updateAddressDetailResponse.isLoading ||
        uploadLabourDocumentResponse.isLoading ||
        isLoading ||
        findByParkingLocationIdResponse.isLoading ? (
        <Loading />
      ) : null}
    </div>
  );
};

export default AddDriver;

const validate: any = {
  0: (values: any) => {
    const errors: any = {};
    if (!values.fullName) errors['fullName'] = 'This field is required'; else if (!/^([a-zA-Z]{3,50}\s*)+$/i.test(values.fullName))
      errors['fullName'] = 'Invalid full name';
    if (!values.registeredPhone) errors['registeredPhone'] = 'This field is required'; else if (!/^[1-9]\d{9}$/i.test(values.registeredPhone))
      errors['registeredPhone'] = 'Phone number must be 10 digits';
    if (values.altPhone && !/^[1-9]\d{9}$/i.test(values.altPhone)) errors['altPhone'] = 'Alternative phone number must be 10 digits';
    if (values.residencePhone && !/^[1-9]\d{9}$/i.test(values.residencePhone)) errors['residencePhone'] = 'Alternative phone number must be 10 digits';
    if (!values.dob) errors['dob'] = 'This field is required';
    if (!values.email) errors['email'] = 'This field is required'; else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email))
      errors['email'] = 'Enter a valid email address';
    if (!values.gender) errors['gender'] = 'This field is required';
    if (!values.nationality) errors['nationality'] = 'This field is required';
    if (!values.religion) errors['religion'] = 'This field is required';
    if (values.maritalStatus === undefined || values.maritalStatus === '') {
      errors['maritalStatus'] = 'This field is required';
    }
    if (!values.diet) errors['diet'] = 'This field is required';
    if (!values.language || values.language.length === 0) {
      errors['language'] = 'Please select at least one language.';
    }
    // if (!values.photo) {
    //   errors['photo'] = 'This field is required';
    // }
    if (!values.businessVertical || values.businessVertical.length === 0) {
      errors['businessVertical'] = 'Please select at least one service type.';
    }
    if (!values.qualification) errors['qualification'] = 'This field is required';
    if (!values.licenseNo) errors['licenseNo'] = 'This field is required';
    else if (!/^[A-Z]{2}-\d{2}\d{4}-\d{7}$/.test(values.licenseNo))
      errors['licenseNo'] = 'License number must follow the format SS-DDYYYY-NNNNNNN';
    if (!values.licExpiryDate) {
      errors["licExpiryDate"] = "This field is required";
    } else {
      const selectedDate = new Date(values.licExpiryDate);
      const today = new Date();
    
      selectedDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);
    
      if (selectedDate <= today) {
        errors["licExpiryDate"] = "Please select a future date";
      }
    }
    
    return errors;
  },
  1: (values: any) => {
    const errors: any = {};

    if (!values.permanentAddress) errors.permanentAddress = 'This field is required';
    //if (!values.location) errors.location = 'This field is required';
    if (!values.addressLineOne) errors.addressLineOne = 'This field is required';
    if (!values.addressLineTwo) errors.addressLineTwo = 'This field is required';
    if (!values.route) errors.route = 'This field is required';
    if (!values.locality) errors.locality = 'This field is required';
    if (!values.city) errors.city = 'This field is required';
    if (!values.zipCode) errors.zipCode = 'This field is required';
    if (!values.state) errors.state = 'This field is required';
    if (!values.country) errors.country = 'This field is required';

    // Zip Code Validation
    if (values.zipCode && !/^\d{6}$/.test(values.zipCode)) {
      errors.zipCode = 'Invalid Zip Code';
    }
    return errors;
  },
  2: (values: any) => {
    const errors: any = {};
    //if (!values.serviceSubCategory) errors['serviceSubCategory'] = 'This field is required';
    // if (!values.asset) errors['asset'] = 'This field is required';
    if (!values.totalExperience) errors['totalExperience'] = 'This field is required';
    if (!values.fullTime && !values.partTime) {
      errors['preferredDuty'] = 'Please select at least one Preferred Duty option';
    }
    if (!values.day && !values.night && !values.outstation) {
      errors['preferredType'] = 'Please select at least one Preferred Type option';
    }
    return errors;
  },

  3: (values: any) => {
    const errors: any = {};
    return errors;
  },

  4: (values: any) => {
    const errors: any = {};
    if (values.trained === undefined) errors['trained'] = 'This field is required';
    if (values.trained === true && !values.trainingDate) {
      errors['trainingDate'] = 'Training Date is required if trained';
    }

    if (values.idCard === undefined) errors['idCard'] = 'This field is required';
    if (values.idCard === true && !values.idCardIssueDate) {
      errors['idCardIssueDate'] = 'ID Card Issue Date is required if ID Card is issued';
    }

    if (values.uniform === undefined) errors['uniform'] = 'This field is required';
    if (values.uniform === true && !values.uniformIssueDate) {
      errors['uniformIssueDate'] = 'Uniform Issue Date is required if Uniform is issued';
    }

    if (values.policeVerification === undefined) errors['policeVerification'] = 'This field is required';
    if (values.criminalVerification === undefined) errors['criminalVerification'] = 'This field is required';
    if (values.backgroundCheck === undefined) errors['backgroundCheck'] = 'This field is required';

    if (!values.certificateIssueDate) {
      errors['certificateIssueDate'] = 'Certificate Issue Date is required';
    }

    return errors;
  },

  5: (values: any) => {
    const errors: any = {};
    return errors;
  },

};

const Personal = ({
  countryData,
  values,
  errors,
  parkingManagementData,
  handleChange,
  handleBlur,
  updateState,
  touched,
  setFieldValue,
}: any) => {
  const [coords, setCoords] = useState<null | any>();
  const [currentLocation, setCurrentLocation] = useState<null | any>();
  const [open, setOpen] = useState(false);
  const [photoPreview, setPhotoPreview] = useState() as any;
  const [businessVerticalOpen, setBusinessVerticalOpen] = useState(false);

  interface Language {
    label: string;
    value: string;
  }

  useEffect(() => {

    navigator.geolocation.getCurrentPosition((position) => {
      const currentCoords = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
      setCoords(currentCoords);
      setCurrentLocation(currentCoords);
    });
  }, []);

  return (

    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box p={3}>
        <Typography variant="h5" fontWeight="bold" mb={3}>
          Personal Details
        </Typography>

        {/* Section 1: Business Details */}
        <Box mb={4} mt={4}>
          <Box
            display="grid"
            gridTemplateColumns={{
              xs: "1fr", // Single column on small screens
              sm: "repeat(2, 1fr)", // Two columns on medium screens
            }}
            gap={3}
          >

            <FormControl fullWidth>
              <InputLabel id="Business Vertical-label">Business Vertical</InputLabel>
              <Select
                id="businessVertical"
                label="Business Vertical"
                multiple
                value={Array.isArray(values.businessVertical) ? values.businessVertical : []}
                onChange={(e) => {
                  const selectedValues = e.target.value;
                  handleChange({
                    target: {
                      name: "businessVertical",
                      value: selectedValues,
                    },
                  });
                }}
                onBlur={handleBlur}
                renderValue={(selected) => (
                  Array.isArray(selected) ? (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {selected.map((value) => (
                        <Chip
                          key={value}
                          label={
                            parkingManagementData?.find((item: any) => item.id === value)?.typeName || value
                          }
                          onDelete={() => {
                            const updatedValues = values.businessVertical.filter(
                              (id: any) => id !== value
                            );
                            handleChange({
                              target: {
                                name: "businessVertical",
                                value: updatedValues,
                              },
                            });
                          }}
                        />
                      ))}
                    </Box>
                  ) : null
                )}
                displayEmpty
                onClose={() => setBusinessVerticalOpen(false)}
                onOpen={() => setBusinessVerticalOpen(true)}
                open={businessVerticalOpen}
              >
                <MenuItem disabled value="0">
                  Select Business Vertical
                </MenuItem>
                {parkingManagementData &&
                  parkingManagementData.map((parkingTypeId: any) => (
                    <MenuItem
                      value={parkingTypeId.id}
                      key={parkingTypeId.id}
                      onClick={() => setBusinessVerticalOpen(false)}
                    >
                      {parkingTypeId.typeName}
                    </MenuItem>
                  ))}
              </Select>
              {errors.businessVertical && (
                <div style={{ color: "red" }}>{errors.businessVertical}</div>
              )}
            </FormControl>


            {/**  <FormControl fullWidth>
            <InputLabel id="service-label">Service</InputLabel>
            <Select
              id="service"
              value={values.service || ""}
              onChange={handleChange}
              onBlur={handleBlur}
              name="service"
              label="Service"
            >
              <MenuItem value="">-- Select Service --</MenuItem>
              <MenuItem value="driver">Driver</MenuItem>
            </Select>
            {errors.service && <div style={{ color: "red" }}>{errors.service}</div>}
          </FormControl> */}
          </Box>
        </Box>

        {/* Section 2: Personal Information */}
        <Box mb={4}>
          <Box
            display="grid"
            gridTemplateColumns={{
              xs: "1fr",
              sm: "repeat(2, 1fr)",
            }}
            gap={3}
          >
            <FormControl fullWidth>
              <TextField
                fullWidth
                id="fullName"
                label="Full Name"
                placeholder="Enter your full name"
                value={values.fullName}
                onChange={handleChange}
                onBlur={handleBlur}
                name="fullName"
              />
              {errors.fullName && <div style={{ color: "red" }}>{errors.fullName}</div>}
            </FormControl>

            <FormControl fullWidth>
              <TextField
                fullWidth
                id="registeredPhone"
                label="Phone Number"
                placeholder="Enter phone number"
                value={values.registeredPhone || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                variant="outlined"
                name="registeredPhone"
              />
              {errors.registeredPhone && <div style={{ color: "red" }}>{errors.registeredPhone}</div>}
            </FormControl>

            <FormControl fullWidth>
              <TextField
                fullWidth
                id="altPhone"
                label="Alternative Phone Number"
                placeholder="Enter alternative phone number"
                value={values.altPhone}
                onChange={handleChange}
                onBlur={handleBlur}
                variant="outlined"
                name="altPhone"
              />
              {errors.altPhone && <div style={{ color: "red" }}>{errors.altPhone}</div>}
            </FormControl>

            <FormControl fullWidth>
              <TextField
                fullWidth
                id="residencePhone"
                label="Residence Phone Number"
                placeholder="Enter Residence phone number"
                value={values.residencePhone || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                variant="outlined"
                name="residencePhone"
              />
              {errors.residencePhone && <div style={{ color: "red" }}>{errors.residencePhone}</div>}
            </FormControl>

            <FormControl fullWidth>
              <DatePicker
                label="Date of Birth"
                value={values.dob || null}
                onChange={(date) => setFieldValue("dob", date)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    id="dob"
                    name="dob"
                    onBlur={handleBlur}
                  //error={Boolean(errors.dob)}
                  />
                )}
              />
              {errors.dob && <div style={{ color: "red" }}>{errors.dob}</div>}
            </FormControl>

            <FormControl fullWidth>
              <TextField
                fullWidth
                id="email"
                label="Email ID"
                placeholder="Enter your email"
                type="email"
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                name="email"
              />
              {errors.email && <div style={{ color: "red" }}>{errors.email}</div>}
            </FormControl>

            <FormControl>
              <FormLabel>Gender</FormLabel>
              <RadioGroup
                row
                name="gender"
                value={values.gender}
                onChange={handleChange}
              >
                <FormControlLabel value="male" control={<Radio />} label="Male" />
                <FormControlLabel value="female" control={<Radio />} label="Female" />
                <FormControlLabel value="other" control={<Radio />} label="Other" />
              </RadioGroup>
              {errors.gender && <div style={{ color: "red" }}>{errors.gender}</div>}
            </FormControl>


            <FormControl fullWidth>
              <InputLabel id="Nationality-label">Nationality</InputLabel>
              <Select
                id="nationality"
                name="nationality"
                label="Nationality"
                value={values.nationality || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                displayEmpty
              >

                {countryData?.length > 0 ? (
                  countryData.map((country: any) => (
                    <MenuItem key={country.id} value={country.id}>
                      {country.name}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No countries available</MenuItem>
                )}
              </Select>
              {errors.nationality && (
                <div style={{ color: 'red', marginTop: '4px' }}>{errors.nationality}</div>
              )}
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id="religion-label">Religion</InputLabel>
              <Select
                id="religion"
                value={values.religion || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                name="religion"
                label="Religion"
              >
                <MenuItem value="">-- Select Religion --</MenuItem>
                <MenuItem value="hindu">Hindu</MenuItem>
                <MenuItem value="muslim">Muslim</MenuItem>
                <MenuItem value="christian">Christian</MenuItem>
                <MenuItem value="sikkhism">Sikhism</MenuItem>
                <MenuItem value="buddhism">Buddhism</MenuItem>
                <MenuItem value="jainism">Jainism</MenuItem>
                <MenuItem value="zoroastrian">Zoroastrian</MenuItem>
                <MenuItem value="other">Other</MenuItem>
              </Select>
              {errors.religion && <div style={{ color: "red" }}>{errors.religion}</div>}
            </FormControl>

            <FormControl>
              <FormLabel>Marital Status</FormLabel>
              <RadioGroup
                row
                name="maritalStatus"
                value={values.maritalStatus === true ? "married" : values.maritalStatus === false ? "single" : ""}
                onChange={(e) => {
                  handleChange({
                    target: {
                      name: "maritalStatus",
                      value: e.target.value === "married",
                    },
                  });
                }}
              >
                <FormControlLabel value="single" control={<Radio />} label="Single" />
                <FormControlLabel value="married" control={<Radio />} label="Married" />
              </RadioGroup>
              {errors.maritalStatus && (
                <div style={{ color: "red" }}>{errors.maritalStatus}</div>
              )}
            </FormControl>

            <FormControl>
              <FormLabel>Diet</FormLabel>
              <RadioGroup
                row
                name="diet"
                value={values.diet}
                onChange={handleChange}
              >
                <FormControlLabel value="vegetarian" control={<Radio />} label="Vegetarian" />
                <FormControlLabel value="nonVegetarian" control={<Radio />} label="Non-Vegetarian" />
              </RadioGroup>
              {errors.diet && <div style={{ color: "red" }}>{errors.diet}</div>}
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id="language-label">Languages</InputLabel>
              <Select
                id="language"
                multiple
                open={open}
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
                value={Array.isArray(values.language) ? values.language : []}
                onChange={(e) => {
                  const selectedValues = e.target.value as string[];
                  console.log("Selected languages:", selectedValues);

                  handleChange({
                    target: {
                      name: "language",
                      value: selectedValues, // Keep as array here
                    },
                  });
                  setOpen(false);
                }}
                onBlur={handleBlur}
                name="language"
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {(selected as string[]).map((value) => (
                      <Chip
                        key={value}
                        label={value}
                        onDelete={() => {
                          const updatedValues = values.language.filter(
                            (lang: string) => lang !== value
                          );
                          handleChange({
                            target: {
                              name: "language",
                              value: updatedValues, // Keep as array here
                            },
                          });
                          setOpen(false);
                        }}
                      />
                    ))}
                  </Box>
                )}
                label="Language"
              >
                <MenuItem value="english">English</MenuItem>
                <MenuItem value="hindi">Hindi</MenuItem>
                <MenuItem value="marathi">Marathi</MenuItem>
                <MenuItem value="arabic">Arabic</MenuItem>
                <MenuItem value="kannad">Kannad</MenuItem>
                <MenuItem value="punjabi">Punjabi</MenuItem>
                <MenuItem value="malyalam">Malyalam</MenuItem>
                <MenuItem value="tamil">Tamil</MenuItem>
                <MenuItem value="kokani">Kokani</MenuItem>
                <MenuItem value="telegu">Telegu</MenuItem>
                <MenuItem value="gujarati">Gujarati</MenuItem>
                <MenuItem value="rajasthani">Rajasthani</MenuItem>
                <MenuItem value="sindhi">Sindhi</MenuItem>
                <MenuItem value="bengali">Bengali</MenuItem>
                <MenuItem value="assami">Assami</MenuItem>
                <MenuItem value="odia">Odia</MenuItem>
                <MenuItem value="other">Other</MenuItem>
              </Select>
              {errors.language && <div style={{ color: "red" }}>{errors.language}</div>}
            </FormControl>

            {/**<FormControl fullWidth>
            <TextField
              fullWidth
              id="photo"
              type="file"
              label="Upload Photo"
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                const target = e.target as HTMLInputElement; 
                const file = target.files?.[0]; 
                if (file) {
                  const reader = new FileReader();
                  reader.readAsDataURL(file);
                  reader.onload = function (event) {
                    if (event.target?.result) {
                      setPhotoPreview(event.target.result as string); 
                    }
                  };
                }
                handleChange(e);
              }}
              name="photo"
            />
            {errors.photo && <div style={{ color: "red" }}>{errors.photo}</div>}

            {photoPreview && (
              <div
                className="container"
                style={{
                  width: "167px",
                  borderRadius: "10px",
                  marginTop: "1rem",
                }}
              >
                <div
                  className="img-holder"
                  style={{
                    margin: "auto",
                    width: "150px",
                    height: "150px",
                    borderRadius: "10px",
                    background: "lightgray",
                  }}
                >
                  <img
                    src={photoPreview}
                    alt="Uploaded Preview"
                    id="img"
                    className="img"
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                      borderRadius: "10px",
                    }}
                  />
                </div>
              </div>
            )}
          </FormControl>  */}

            <FormControl fullWidth>
              <TextField
                fullWidth
                id="licenseNo"
                label="License Number"
                placeholder="Enter your License Number"
                value={values.licenseNo}
                onChange={handleChange}
                onBlur={handleBlur}
                name="licenseNo"
              />
              {errors.licenseNo && <div style={{ color: "red" }}>{errors.licenseNo}</div>}
            </FormControl>

            <FormControl fullWidth>
              <DatePicker
                label="License Expiry Date"
                value={values.licExpiryDate || null}
                minDate={new Date()}
                onChange={(date) => setFieldValue("licExpiryDate", date)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    id="licExpiryDate"
                    name="licExpiryDate"
                    onBlur={handleBlur}
                  //error={Boolean(errors.licExpiryDate)}
                  />
                )}
              />
              {errors.licExpiryDate && <div style={{ color: "red" }}>{errors.licExpiryDate}</div>}
            </FormControl>

          </Box>
        </Box>

        {/* Section 3: Qualification Details */}
        <Box>
          <Typography variant="h6" fontWeight="bold" mb={2}>
            Qualification Details
          </Typography>
          <Box
            display="grid"
            mt={2}
            gridTemplateColumns={{
              xs: "1fr",
              sm: "repeat(2, 1fr)",
            }}
            gap={3}
          >
            <FormControl fullWidth>
              <InputLabel id="qualification-label">Education Level</InputLabel>
              <Select
                id="qualification"
                value={values.qualification || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                name="qualification"
                label="Qualification"
              >
                <MenuItem value="">-- Select Qualification --</MenuItem>
                <MenuItem value="7th_pass">7th Pass or Less</MenuItem>
                <MenuItem value="graduate">Graduate</MenuItem>
                <MenuItem value="postGraduate">Post Graduate</MenuItem>
                <MenuItem value="others">Others</MenuItem>
              </Select>
              {errors.qualification && <div style={{ color: "red" }}>{errors.qualification}</div>}
            </FormControl>
          </Box>
        </Box>
      </Box>

    </LocalizationProvider>
  );
};

const Address = ({
  countryData,
  stateData,
  cityData,
  values,
  errors,
  setLocation,
  handleChange,
  selectedCountryId,
  selectedStateId,
  selectedCityId,
  handleCountryChange,
  handleStateChange,
  handleCityChange,
  state,
  token,
  handleBlur,
  selectedLabourId,
  setFieldValue,
}: any) => {
  const [coords, setCoords] = useState<null | any>();
  const [currentLocation, setCurrentLocation] = useState<null | any>();
  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position) => {
      const currentCoords = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
      setCoords(currentCoords);
      setCurrentLocation(currentCoords);
    });
  }, []);

  const locationChange = (item: any) => {
    setLocation(item);
  };


  return (
    <Box p={3}>
      <Typography variant="h5" fontWeight="bold" mb={3}>
        Address Details
      </Typography>

      {/* Section: Current Address */}
      <Box mb={4} mt={2}>
        <Typography variant="h6" fontWeight="bold" mb={2}>
          Current Address
        </Typography>
        <Box mt={2} display="grid" gridTemplateColumns={{ xs: "1fr", sm: "repeat(2, 1fr)" }} gap={3}>
          <FormControl fullWidth>
            <LocationSearchInput
              disabled={state.editMode === true}
              locationDetail={(item: any) => locationChange(item)}
              value={values.location}
            />
          </FormControl>

          <FormControl fullWidth>
            <TextField
              id="addressLineOne"
              label="Address Line 1"
              placeholder="Flat No, Bldg..."
              value={values.addressLineOne}
              onChange={handleChange}
              onBlur={handleBlur}
              name="addressLineOne"
            />
            {errors.addressLineOne && <div style={{ color: "red" }}>{errors.addressLineOne}</div>}
          </FormControl>

          <FormControl fullWidth>
            <TextField
              id="addressLineTwo"
              label="Address Line 2"
              placeholder="Street..."
              value={values.addressLineTwo}
              onChange={handleChange}
              onBlur={handleBlur}
              name="addressLineTwo"
            />
            {errors.addressLineTwo && <div style={{ color: "red" }}>{errors.addressLineTwo}</div>}
          </FormControl>

          <FormControl fullWidth>
            <TextField
              id="route"
              label="Route"
              placeholder="Route"
              value={values.route}
              onChange={handleChange}
              onBlur={handleBlur}
              name="route"
            />
            {errors.route && <div style={{ color: "red" }}>{errors.route}</div>}
          </FormControl>

          <FormControl fullWidth>
            <TextField
              id="locality"
              label="Locality"
              placeholder="Locality"
              value={values.locality}
              onChange={handleChange}
              onBlur={handleBlur}
              name="locality"
            />
            {errors.locality && <div style={{ color: "red" }}>{errors.locality}</div>}
          </FormControl>

          {/* Country Dropdown */}
          <FormControl fullWidth>
            <InputLabel id="Country-label">Country</InputLabel>
            <Select
              id="country"
              name="country"
              label="Country"
              value={values.country || ''}
              onChange={(e) => {
                const countryId = parseInt(e.target.value);
                //console.log('Selected Country ID:', countryId); 
                //console.log('Country Data:', countryData);
                handleCountryChange(countryId);
                setFieldValue('country', countryId);
              }}
            >
              <MenuItem value="">Select Country</MenuItem>
              {countryData.map((country: any) => (
                <MenuItem key={country.id} value={country.id}>
                  {country.name}
                </MenuItem>
              ))}
            </Select>
            {errors.country && <div style={{ color: 'red' }}>{errors.country}</div>}
          </FormControl>

          {/* State Dropdown */}
          <FormControl fullWidth>
            <InputLabel id="State-label">State</InputLabel>
            <Select
              id="state"
              name="state"
              label="State"
              value={values.state || ''}
              onChange={(e) => {
                const stateId = parseInt(e.target.value);
                //console.log('Selected State ID:', stateId); 
                //console.log('State Data:', stateData);
                handleStateChange(stateId);
                setFieldValue('state', stateId);
              }}
              disabled={!stateData.length}
            >
              <MenuItem value="">Select State</MenuItem>
              {stateData.map((state: any) => (
                <MenuItem key={state.id} value={state.id}>
                  {state.name}
                </MenuItem>
              ))}
            </Select>
            {errors.state && <div style={{ color: 'red' }}>{errors.state}</div>}
          </FormControl>

          {/* City Dropdown */}
          <FormControl fullWidth>
            <InputLabel id="City-label">City</InputLabel>
            <Select
              id="city"
              name="city"
              label="City"
              value={values.city || ''}
              onChange={(e) => {
                const cityId = parseInt(e.target.value);
                //console.log('Selected City ID:', cityId);
                //console.log('City Data:', cityData);
                handleCityChange(cityId);
                setFieldValue('city', cityId);
              }}
              disabled={!cityData.length}
            >
              <MenuItem value="">Select City</MenuItem>
              {cityData.map((city: any) => (
                <MenuItem key={city.id} value={city.id}>
                  {city.name}
                </MenuItem>
              ))}
            </Select>
            {errors.city && <div style={{ color: 'red' }}>{errors.city}</div>}
          </FormControl>


          <FormControl fullWidth>
            <TextField
              id="zipCode"
              label="Zip Code"
              placeholder="Zip Code"
              value={values.zipCode}
              onChange={handleChange}
              onBlur={handleBlur}
              name="zipCode"
            />
            {errors.zipCode && <div style={{ color: "red" }}>{errors.zipCode}</div>}
          </FormControl>




        </Box>
      </Box>

      <Box mb={4}>
        <Box display="flex" gap={4}>
          <FormControlLabel
            control={
              <Checkbox
                checked={values.currentsameaspermanent}
                onChange={handleChange}
                name="currentsameaspermanent"
              />
            }
            label="Is current address same as permanent address?"
          />
        </Box>
        {errors.currentsameaspermanent && (
          <div style={{ color: 'red' }}>{errors.currentsameaspermanent}</div>
        )}
      </Box>

      {/* Section: Permanent Address */}
      <Box mb={4}>
        <Typography variant="h6" fontWeight="bold" mb={4}>
          Permanent Address
        </Typography>
        <FormControl fullWidth >
          <TextField
            id="permanentAddress"
            label="Permanent Address"
            placeholder="Enter your permanent address"
            multiline
            rows={4}
            value={values.permanentAddress}
            onChange={handleChange}
            onBlur={handleBlur}
            name="permanentAddress"
            sx={{ mt: 2 }}
          />
          {errors.permanentAddress && <div style={{ color: "red" }}>{errors.permanentAddress}</div>}
        </FormControl>
      </Box>
    </Box>
  );
};

const JobDetails = ({
  values,
  errors,
  state,
  token,
  selectedLabourId,
  handleChange,
  handleBlur,
  setFieldValue,
}: any) => {

  return (
    <Box p={3}>
      <Typography variant="h5" fontWeight="bold" mb={3}>
        Job Details
      </Typography>

      {/* Section 1: Service Sub Category & Asset
  <Box mb={4} mt={2} display="grid" gridTemplateColumns={{ xs: "1fr", sm: "repeat(2, 1fr)" }} gap={3}>
    <FormControl fullWidth>
      <InputLabel id="serviceSubCategory-label">Service Sub Category</InputLabel>
      <Select
        id="serviceSubCategory"
        value={values.serviceSubCategory || ""}
        onChange={handleChange}
        onBlur={handleBlur}
        name="serviceSubCategory"
        label="Service Sub Category"
      >
        <MenuItem value="">Select a category...</MenuItem>
      </Select>
      {errors.serviceSubCategory && <div style={{ color: "red" }}>{errors.serviceSubCategory}</div>}
    </FormControl>

    <FormControl fullWidth>
      <InputLabel id="asset-label">Asset</InputLabel>
      <Select
        id="asset"
        value={values.asset || ""}
        onChange={handleChange}
        onBlur={handleBlur}
        name="asset"
        label="Asset"
      >
        <MenuItem value="">Select an asset...</MenuItem>
      </Select>
      {errors.asset && <div style={{ color: "red" }}>{errors.asset}</div>}
    </FormControl>
  </Box>

  */}

      {/* Section 2: Experience, Preferred Duty, Preferred Type */}
      <Box mb={4}>
        <Box display="grid" gridTemplateColumns={{ xs: "1fr", sm: "repeat(2, 1fr)" }} gap={3}>
          <FormControl fullWidth>
            <TextField
              id="totalExperience"
              label="Total Experience"
              placeholder="Enter total experience"
              value={values.totalExperience}
              onChange={handleChange}
              onBlur={handleBlur}
              name="totalExperience"
            />
            {errors.totalExperience && <div style={{ color: "red" }}>{errors.totalExperience}</div>}
          </FormControl>

          <FormControl fullWidth>
            <TextField
              id="overseasExperience"
              label="Overseas Experience"
              placeholder="Enter overseas experience"
              value={values.overseasExperience}
              onChange={handleChange}
              onBlur={handleBlur}
              name="overseasExperience"
            />
            {errors.overseasExperience && <div style={{ color: "red" }}>{errors.overseasExperience}</div>}
          </FormControl>
        </Box>

        {/* Preferred Duty */}
        <Box mb={4} mt={2}>
          <Typography variant="h6" fontWeight="bold" mb={2}>
            Preferred Duty
          </Typography>
          <Box display="flex" gap={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={values.fullTime}
                  onChange={(e) => handleChange({ target: { name: 'fullTime', value: e.target.checked } })}
                  name="fullTime"
                />
              }
              label="Full Time"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={values.partTime}
                  onChange={(e) => handleChange({ target: { name: 'partTime', value: e.target.checked } })}
                  name="partTime"
                />
              }
              label="Part Time"
            />
          </Box>
          {errors.preferredDuty && (
            <div style={{ color: 'red' }}>{errors.preferredDuty}</div>
          )}
        </Box>

        {/* Preferred Type */}
        <Box mb={4}>
          <Typography variant="h6" fontWeight="bold" mb={2}>
            Preferred Type
          </Typography>
          <Box display="flex" gap={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={values.day}
                  onChange={(e) => handleChange({ target: { name: 'day', value: e.target.checked } })}
                  name="day"
                />
              }
              label="Day"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={values.night}
                  onChange={(e) => handleChange({ target: { name: 'night', value: e.target.checked } })}
                  name="night"
                />
              }
              label="Night"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={values.outstation}
                  onChange={(e) => handleChange({ target: { name: 'outstation', value: e.target.checked } })}
                  name="outstation"
                />
              }
              label="Outstation"
            />
          </Box>
          {errors.preferredType && (
            <div style={{ color: 'red' }}>{errors.preferredType}</div>
          )}
        </Box>



      </Box>

      {/* Section 3: Remarks */}
      <Box mb={4}>
        <Typography variant="h6" fontWeight="bold" mb={2}>
          Remarks
        </Typography>
        <FormControl fullWidth>
          <TextField
            id="remarks"
            label="Enter Remarks"
            placeholder="Add any remarks or additional details"
            multiline
            rows={4}
            value={values.remarks || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            name="remarks"
            sx={{ mt: 2 }}
          />
          {errors.remarks && <div style={{ color: "red" }}>{errors.remarks}</div>}
        </FormControl>
      </Box>
    </Box>
  );
};

const References = ({
  state,
  saveReferenceData,
  updateReferenceData,
  deleteReferenceData,
  setAllSavedReferences,
  references,
  EditIcon,
  IconButton,
  DeleteIcon,
  SaveIcon,
  DoneIcon,
  Tooltip,
  classes,
  setReferences,
  setState }: any) => {
  type Errors = {
    referenceName?: string;
    phoneNo?: string;
    referenceType?: string;
  };

  const [newReference, setNewReference] = useState(false);
  const [currentReference, setCurrentReference] = useState({
    referenceName: '',
    phoneNo: '',
    referenceType: '',
    feedback: -1,
  });
  const [errors, setErrors] = useState<Errors>({});
  const [editIndex, setEditIndex] = useState<number | null>(null);

  const validate = (values: typeof currentReference): Errors => {
    const validationErrors: Errors = {};
    if (!values.referenceName) validationErrors.referenceName = 'Reference Name is required';
    if (!values.phoneNo)
      validationErrors.phoneNo = 'Reference Contact is required';
    else if (!/^[1-9]\d{9}$/.test(values.phoneNo))
      validationErrors.phoneNo = 'Reference Contact number must be 10 digits';
    if (!values.referenceType) validationErrors.referenceType = 'Reference Type is required';

    return validationErrors;
  };

  const handleAddRow = () => {
    setNewReference(true);
    setCurrentReference({
      referenceName: '',
      phoneNo: '',
      referenceType: '',
      feedback: -1,
    });
    setErrors({});

    setState({
      ...state,
      editMode: false,
    });
  };

  const handleSaveNewReference = async () => {
    const validationErrors = validate(currentReference);
    if (Object.keys(validationErrors).length === 0) {
      await saveReferenceData(currentReference); // Use saveReferenceData from parent for API call
      setReferences((prev: any) => [
        ...prev,
        { ...currentReference, saved: true }, // Mark as saved
      ]);
      setNewReference(false);
      setErrors({});
      checkAllReferencesSaved(); // Check if all references are saved
    } else {
      setErrors(validationErrors);
    }
  };

  const handleEditReference = (index: number) => {
    setEditIndex(index);
    setCurrentReference(references[index]);
    setErrors({});

    //  setState({
    //    ...state, 
    //     editMode: true, 
    //  });
  };

  const handleSaveEditedReference = async (index: number, refId: number | undefined) => {

    const validationErrors = validate(currentReference);
    if (Object.keys(validationErrors).length === 0) {
      await updateReferenceData(currentReference, refId);
      setReferences((prev: any) => {
        const updatedReferences = [...prev];
        updatedReferences[editIndex!] = { ...currentReference, saved: true };
        return updatedReferences;
      });
      // Reset states after update
      setEditIndex(null);
      setCurrentReference({
        referenceName: '',
        phoneNo: '',
        referenceType: '',
        feedback: -1,
      });
      setErrors({});
      checkAllReferencesSaved();
    } else {
      setErrors(validationErrors);
    }
  };

  const handleDeleteReference = async (index: number, refId: number | undefined) => {
    await deleteReferenceData(currentReference, refId);
    setReferences((prev: any[]) => prev.filter((_, i) => i !== index));
    checkAllReferencesSaved();
  };

  const checkAllReferencesSaved = () => {
    const allSaved = references.every((ref: { saved: any; }) => ref.saved);
    setAllSavedReferences(allSaved);
  };

  return (
    <div>
      <Box p={3}>
        <Typography variant="h5" fontWeight="bold" mb={3}>
          References
        </Typography>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Reference Name</TableCell>
                <TableCell>Reference Contact</TableCell>
                <TableCell>Reference Type</TableCell>
                <TableCell>Feedback</TableCell>
                <TableCell>
                  <Button variant="contained" color="primary" className={classes.button}
                    style={{ color: 'white', backgroundColor: '#E23744' }} onClick={handleAddRow}>
                    Add Reference
                  </Button>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {references.map((ref: Reference, index: number) => (
                <TableRow key={ref.id}>
                  <TableCell>
                    {editIndex === index ? (
                      <TextField
                        fullWidth
                        value={currentReference.referenceName}
                        onChange={(e) =>
                          setCurrentReference({
                            ...currentReference,
                            referenceName: e.target.value,
                          })
                        }
                      />
                    ) : (
                      ref.referenceName
                    )}
                    {errors.referenceName && (
                      <div style={{ color: 'red' }}>{errors.referenceName}</div>
                    )}
                  </TableCell>
                  <TableCell>
                    {editIndex === index ? (
                      <TextField
                        fullWidth
                        value={currentReference.phoneNo}
                        onChange={(e) =>
                          setCurrentReference({
                            ...currentReference,
                            phoneNo: e.target.value,
                          })
                        }
                      />
                    ) : (
                      ref.phoneNo
                    )}
                    {errors.phoneNo && (
                      <div style={{ color: 'red' }}>{errors.phoneNo}</div>
                    )}
                  </TableCell>
                  <TableCell>
                    {editIndex === index ? (
                      <Select
                        fullWidth
                        value={currentReference.referenceType}
                        onChange={(e) =>
                          setCurrentReference({
                            ...currentReference,
                            referenceType: e.target.value,
                          })
                        }
                      >
                        <MenuItem value="" disabled>
                          ---Select Reference Type---
                        </MenuItem>
                        <MenuItem value="Friend">Friend</MenuItem>
                        <MenuItem value="Relative">Relative</MenuItem>
                        <MenuItem value="Room Owner">Room Owner</MenuItem>
                        <MenuItem value="Previous Employer">Previous Employer</MenuItem>
                      </Select>
                    ) : (
                      ref.referenceType
                    )}
                    {errors.referenceType && (
                      <div style={{ color: 'red' }}>{errors.referenceType}</div>
                    )}
                  </TableCell>
                  <TableCell>
                    {editIndex === index ? (
                      <Select
                        fullWidth
                        value={String(currentReference.feedback)}
                        onChange={(e) =>
                          setCurrentReference({
                            ...currentReference,
                            feedback: parseInt(e.target.value, 10),
                          })
                        }
                      >
                        <MenuItem value="0">Unsatisfied</MenuItem>
                        <MenuItem value="1">Expecting Improvement</MenuItem>
                        <MenuItem value="2">Good</MenuItem>
                        <MenuItem value="3">Very Good</MenuItem>
                        <MenuItem value="4">Excellent</MenuItem>
                      </Select>
                    ) : (
                      ['Unsatisfied', 'Expecting Improvement', 'Good', 'Very Good', 'Excellent'][
                      ref.feedback
                      ]
                    )}
                  </TableCell>
                  <TableCell>
                    {editIndex === index ? (
                      <Tooltip title="Update"><IconButton onClick={() => handleSaveEditedReference(index, Number(ref.id))}><DoneIcon sx={{ color: '#e23744' }} /></IconButton></Tooltip>
                    ) : (
                      <>
                        <Tooltip title="Edit"><IconButton onClick={() => handleEditReference(index)}> <EditIcon sx={{ color: '#e23744' }} /></IconButton></Tooltip>
                        <Tooltip title="Delete"><IconButton onClick={() => handleDeleteReference(index, Number(ref.id))}><DeleteIcon sx={{ color: '#e23744' }} /></IconButton></Tooltip>
                      </>
                    )}
                  </TableCell>
                </TableRow>
              ))}

              {newReference && (
                <TableRow>
                  <TableCell>
                    <TextField
                      fullWidth
                      value={currentReference.referenceName}
                      onChange={(e) =>
                        setCurrentReference({
                          ...currentReference,
                          referenceName: e.target.value,
                        })
                      }
                    />
                    {errors.referenceName && (
                      <div style={{ color: 'red' }}>{errors.referenceName}</div>
                    )}
                  </TableCell>
                  <TableCell>
                    <TextField
                      fullWidth
                      value={currentReference.phoneNo}
                      onChange={(e) =>
                        setCurrentReference({
                          ...currentReference,
                          phoneNo: e.target.value,
                        })
                      }
                    />
                    {errors.phoneNo && (
                      <div style={{ color: 'red' }}>{errors.phoneNo}</div>
                    )}
                  </TableCell>
                  <TableCell>
                    <Select
                      fullWidth
                      value={currentReference.referenceType}
                      onChange={(e) =>
                        setCurrentReference({
                          ...currentReference,
                          referenceType: e.target.value,
                        })
                      }
                    >
                      <MenuItem value="" disabled>
                        ---Select Reference Type---
                      </MenuItem>
                      <MenuItem value="Friend">Friend</MenuItem>
                      <MenuItem value="Relative">Relative</MenuItem>
                      <MenuItem value="Room Owner">Room Owner</MenuItem>
                      <MenuItem value="Previous Employer">Previous Employer</MenuItem>
                    </Select>
                  </TableCell>
                  <TableCell>
                    <Select
                      fullWidth
                      value={String(currentReference.feedback)}
                      onChange={(e) =>
                        setCurrentReference({
                          ...currentReference,
                          feedback: parseInt(e.target.value, 10),
                        })
                      }
                    >
                      <MenuItem value="0">Unsatisfied</MenuItem>
                      <MenuItem value="1">Expecting Improvement</MenuItem>
                      <MenuItem value="2">Good</MenuItem>
                      <MenuItem value="3">Very Good</MenuItem>
                      <MenuItem value="4">Excellent</MenuItem>
                    </Select>
                  </TableCell>
                  <TableCell>
                    <Tooltip title="Save"><IconButton onClick={handleSaveNewReference}><SaveIcon sx={{ color: '#e23744' }} /></IconButton></Tooltip>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </div>
  );
};

const OfficialWork = ({
  values,
  errors,
  handleChange,
  handleBlur,
  setFieldValue,
}: any) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div>
        <Box p={3}>
          <Typography variant="h5" fontWeight="bold" mb={3}>
            Official Details
          </Typography>

          <Grid container spacing={3} mb={4}>
            {/* Trained */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <FormLabel>Trained</FormLabel>
                <RadioGroup
                  row
                  name="trained"
                  value={
                    values.trained === true
                      ? "yes"
                      : values.trained === false
                        ? "no"
                        : ""
                  }
                  onChange={(e) => {
                    const isTrained = e.target.value === "yes";
                    handleChange({
                      target: {
                        name: "trained",
                        value: isTrained,
                      },
                    });
                    if (!isTrained) {
                      setFieldValue("trainingDate", null);
                    }
                  }}
                >
                  <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
                {errors.trained && <div style={{ color: "red" }}>{errors.trained}</div>}
              </FormControl>
            </Grid>

            {/* Training Date */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <DatePicker
                  label="Training Date"
                  value={values.trainingDate || null}
                  onChange={(date) =>
                    setFieldValue("trainingDate", date?.toISOString() || null)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="trainingDate"
                      onBlur={handleBlur}
                      disabled={values.trained === false}
                    />
                  )}
                />
                {errors.trainingDate && values.trained && (
                  <div style={{ color: "red" }}>{errors.trainingDate}</div>
                )}
              </FormControl>
            </Grid>

            {/* ID Card Issued */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <FormLabel>ID Card Issued</FormLabel>
                <RadioGroup
                  row
                  name="idCard"
                  value={values.idCard === true ? "yes" : values.idCard === false ? "no" : ""}
                  onChange={(e) => {
                    const isIdCardIssued = e.target.value === "yes";
                    handleChange({
                      target: {
                        name: "idCard",
                        value: isIdCardIssued,
                      },
                    });
                    if (!isIdCardIssued) {
                      setFieldValue("idCardIssueDate", null); // Clear the date field if "No" is selected
                    }
                  }}
                >
                  <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
                {errors.idCard && <div style={{ color: "red" }}>{errors.idCard}</div>}
              </FormControl>
            </Grid>

            {/* ID Card Issue Date */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <DatePicker
                  label="ID Card Issue Date"
                  value={values.idCardIssueDate || null}
                  onChange={(date) =>
                    setFieldValue("idCardIssueDate", date?.toISOString() || null)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="idCardIssueDate"
                      onBlur={handleBlur}
                      disabled={values.idCard === false}
                    />
                  )}
                />
                {errors.idCardIssueDate && values.idCard && (
                  <div style={{ color: "red" }}>{errors.idCardIssueDate}</div>
                )}
              </FormControl>
            </Grid>

            {/* Uniform Issued */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <FormLabel>Uniform Issued</FormLabel>
                <RadioGroup
                  row
                  name="uniform"
                  value={values.uniform === true ? "yes" : values.uniform === false ? "no" : ""}
                  onChange={(e) => {
                    const isUniformIssued = e.target.value === "yes";
                    handleChange({
                      target: {
                        name: "uniform",
                        value: isUniformIssued,
                      },
                    });
                    if (!isUniformIssued) {
                      setFieldValue("uniformIssueDate", null); // Clear the date if "No" is selected
                    }
                  }}
                >
                  <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
                {errors.uniform && <div style={{ color: "red" }}>{errors.uniform}</div>}
              </FormControl>
            </Grid>

            {/* Uniform Issue Date */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <DatePicker
                  label="Uniform Issue Date"
                  value={values.uniformIssueDate || null}
                  onChange={(date) =>
                    setFieldValue("uniformIssueDate", date?.toISOString() || null)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="uniformIssueDate"
                      onBlur={handleBlur}
                      disabled={values.uniform === false}
                    />
                  )}
                />
                {errors.uniformIssueDate && values.uniform && (
                  <div style={{ color: "red" }}>{errors.uniformIssueDate}</div>
                )}
              </FormControl>
            </Grid>
          </Grid>

          <Typography variant="h5" fontWeight="bold" mb={3}>
            Legal Information
          </Typography>

          <Grid container spacing={3}>
            {/* Police Verification */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <FormLabel>Police Verification</FormLabel>
                <RadioGroup
                  row
                  name="policeVerification"
                  value={
                    values.policeVerification === true
                      ? "yes"
                      : values.policeVerification === false
                        ? "no"
                        : ""
                  }
                  onChange={(e) => {
                    handleChange({
                      target: {
                        name: "policeVerification",
                        value: e.target.value === "yes",
                      },
                    });
                  }}
                >
                  <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
                {errors.policeVerification && (
                  <div style={{ color: "red" }}>{errors.policeVerification}</div>
                )}
              </FormControl>
            </Grid>

            {/* Court/Criminal Verification */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <FormLabel>Court/Criminal Verification</FormLabel>
                <RadioGroup
                  row
                  name="criminalVerification"
                  value={
                    values.criminalVerification === true
                      ? "yes"
                      : values.criminalVerification === false
                        ? "no"
                        : ""
                  }
                  onChange={(e) => {
                    handleChange({
                      target: {
                        name: "criminalVerification",
                        value: e.target.value === "yes",
                      },
                    });
                  }}
                >
                  <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
                {errors.criminalVerification && (
                  <div style={{ color: "red" }}>{errors.criminalVerification}</div>
                )}
              </FormControl>
            </Grid>

            {/* Other Background Check */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <FormLabel>Other Background Check</FormLabel>
                <RadioGroup
                  row
                  name="backgroundCheck"
                  value={
                    values.backgroundCheck === true
                      ? "yes"
                      : values.backgroundCheck === false
                        ? "no"
                        : ""
                  }
                  onChange={(e) => {
                    handleChange({
                      target: {
                        name: "backgroundCheck",
                        value: e.target.value === "yes",
                      },
                    });
                  }}
                >
                  <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
                {errors.backgroundCheck && (
                  <div style={{ color: "red" }}>{errors.backgroundCheck}</div>
                )}
              </FormControl>
            </Grid>

            {/* Certificate Issue Date */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <DatePicker
                  label="Certificate Issue Date"
                  value={values.certificateIssueDate || null}
                  onChange={(date) =>
                    setFieldValue("certificateIssueDate", date?.toISOString() || null)
                  }
                  renderInput={(params) => (
                    <TextField {...params} name="certificateIssueDate" onBlur={handleBlur} />
                  )}
                />
                {errors.certificateIssueDate && (
                  <div style={{ color: "red" }}>{errors.certificateIssueDate}</div>
                )}
              </FormControl>
            </Grid>

            {/* Remarks */}
            <Grid item xs={12}>
              <FormControl fullWidth>
                <TextField
                  id="remarksow"
                  label="Remarks"
                  multiline
                  rows={4}
                  value={values.remarksow || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  name="remarksow"
                />
                {errors.remarksow && <div style={{ color: "red" }}>{errors.remarksow}</div>}
              </FormControl>
            </Grid>
          </Grid>
        </Box>
      </div>
    </LocalizationProvider>
  );
};

const UploadDocuments = ({
  values,
  errors,
  state,
  handleChange,
  handleBlur,
  labourDocuments,
  uploadDocuments,
  setUploadDocuments,
  deleteDocumentData,
  onUpload,
  IconButton,
  DeleteIcon,
  SaveAltIcon,
  Tooltip,
  setFieldValue,
  saveLabourDocumentDataToServer,
  signedUrl,
  classes,
}: any) => {
  const [showSignedUrl, setShowSignedUrl] = useState<boolean>(false);
  const handleDeleteDocument = async (index: number, docId: number | undefined) => {
    console.log("Child Component - Handle Delete - Index:", index, "Doc ID:", docId);
    await deleteDocumentData(values, docId); // Pass docId to parent function
    setUploadDocuments((prev: any[]) => prev.filter((_, i) => i !== index));
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const allowedTypes = ["image/jpeg", "image/jpg"];
      if (!allowedTypes.includes(file.type)) {
        toast.error("Invalid file type. Only JPG files are allowed.");
        return;
      }
      onUpload(file);
    }
  };

  const handleSave = async () => {
    try {
      await saveLabourDocumentDataToServer(values);

      const file = (document.getElementById("uploadFile") as HTMLInputElement)?.files?.[0];
      if (file) {
        const newDocument = {
          documentType: values.documentType,
          fileName: file.name,
          fileUrl: URL.createObjectURL(file),
        };

        setUploadDocuments((prev: any) => [...prev, newDocument]);
        setFieldValue("documentType", "");
        setFieldValue("uploadFile", "");

        setShowSignedUrl(true);

        toast.success("Document details saved successfully!");
      }
    } catch (error) {
      const errorMessage =
        (error as any)?.data?.message ||
        (error instanceof Error ? error.message : "An error occurred while saving the document.");
      toast.error(errorMessage);
      console.error(error);
    }
  };

  const uploadedDocumentTypes = uploadDocuments.map((doc: any) => doc.docType);

  //const fetchedDocumentTypes = state.editMode ? uploadDocuments.map((doc: any) => doc.docType) : [];

  return (
    <div>
      <Box p={3}>
        <Typography variant="h5" fontWeight="bold" mb={3}>
          Upload Documents
        </Typography>
        <Box mb={4} mt={2} color="red">
          <Typography variant="body2">Driving License is Mandatory</Typography>
          <Typography variant="body2">Driver Photo is Mandatory</Typography>
          <Typography variant="body2">Aadhar Card is Mandatory</Typography>
          <Typography variant="body2">
            You can upload a document from PAN card, Passport. One document from
            Police Verification, Rent Agreement, Election Card, Electricity Bill is
            Mandatory.
          </Typography>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel id="documenttype-label">Document Type</InputLabel>
              <Select
                id="documentType"
                label="Select Document To Upload"
                value={values.documentType}
                onChange={(e) => {
                  handleChange(e);
                  console.log("Selected Document Type:", e.target.value);
                }}
                onBlur={handleBlur}
                displayEmpty
                name="documentType"
              >
                <MenuItem value="0" disabled>
                  --Select Document--
                </MenuItem>
                {labourDocuments &&
                  labourDocuments.map((documentType: any) => (
                    <MenuItem
                      value={documentType.code}
                      key={documentType.code}
                      disabled={
                        uploadedDocumentTypes.includes(documentType.code)
                      }
                    >
                      {documentType.displayValue}
                    </MenuItem>
                  ))}
              </Select>
              {errors.documentType && (
                <div style={{ color: "red" }}>{errors.documentType}</div>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                id="uploadFile"
                type="file"
                InputLabelProps={{ shrink: true }}
                onChange={handleFileChange}
                name="uploadFile"
              />
              {errors.uploadFile && (
                <div style={{ color: "red" }}>{errors.uploadFile}</div>
              )}
            </FormControl>
          </Grid>
        </Grid>
        <Box mt={3}>
          <Button variant="contained" color="primary" className={classes.button}
            style={{ color: 'white', backgroundColor: '#E23744' }} onClick={handleSave}>
            Upload
          </Button>
        </Box>
        <Box mt={4}>
          <Typography variant="h6" gutterBottom>
            Uploaded Documents
          </Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Document Type</TableCell>
                  <TableCell>File Name</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {uploadDocuments.length > 0 ? (
                  uploadDocuments.map((doc: any, index: number) => (
                    <TableRow key={doc.id}>
                      <TableCell> {doc.docType}</TableCell>
                      <TableCell>{doc.path?.split('/').pop()?.split('?')[0] || 'N/A'}</TableCell>
                      <TableCell>
                        <Tooltip title="Delete"><IconButton onClick={() => handleDeleteDocument(index, Number(doc.id))}><DeleteIcon sx={{ color: '#e23744' }} /></IconButton></Tooltip>
                        <Tooltip title="Download"><IconButton onClick={() => {
                          const fileUrl = doc.path;
                          window.open(fileUrl, "_blank");
                        }}><SaveAltIcon sx={{ color: '#e23744' }} /></IconButton></Tooltip>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      No documents uploaded yet.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </div>
  );
};